<ea-svg
  [svgClass]="setIconClass()"
  [minWidth]="size"
  [minHeight]="size"
  [width]="size"
  [height]="size"
></ea-svg>
